import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TradingViewService } from '@zero/shared/charts/ui-charts-base';
import { DepotChartSerie, Period } from '@zero/statistics/domain';
import { MyChartModel } from './my-chart.model';

@Directive()
export class MyChartBase implements AfterViewInit, OnInit, OnChanges {
  @Input() public chartWithCash: DepotChartSerie[];
  @Input() public chartWithoutCash: DepotChartSerie[];
  @Input() public accountTotal: number;
  @Input() public cashTotal: number;
  @Input() public loading: boolean;
  @Input() public handleResize = true;

  @Output() public readonly changePeriod = new EventEmitter<number | Period>();

  public model?: MyChartModel;
  public initialized = false;

  @ViewChild('chart', { static: true }) protected readonly _chart: ElementRef<HTMLDivElement>;
  readonly #chartService = inject(TradingViewService);

  @HostListener('window:resize')
  public onResize() {
    if (!this.handleResize) {
      return;
    }
    this._chart?.nativeElement && this.#chartService?.resize(this._chart.nativeElement.getBoundingClientRect().width, 200);
  }

  public ngOnInit(): void {
    this.#createModel();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    changes['chartWithoutCash']?.currentValue && changes['chartWithCash']?.currentValue && this.init();
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.setup();
      this.initialized = true;
    }, 0);
  }

  public toggleCash = (withCash: boolean): void => {
    this.model.withCash = withCash;
    this.#chartService.toggleCashLine(this.model.withCash, this.chartWithCash);
  };

  public togglePeriod = (value: number | Period): void => {
    this.model.periods = this.model.periods.map((period) => ({
      ...period,
      isActive: period.value === value,
    }));
    this.changePeriod.emit(value);
  };

  protected reset = (): void => {
    this._chart.nativeElement.innerHTML = '';
    this.setup();
    this.init();
  };

  public init = (): void => {
    this.#chartService.initMyChart(this.chartWithoutCash, this.model?.withCash ? this.chartWithCash : null);
  };

  public setup = (): void => this.#chartService.setupMyChart(this._chart.nativeElement);

  #createModel() {
    const periodPrefix = 'statistics.my-chart.periods.';
    const currentYear = new Date().getFullYear();
    this.model = {
      withCash: false,
      periods: [
        {
          value: Period.THREE_MONTHS,
          label: periodPrefix + Period.THREE_MONTHS,
          isActive: false,
        },
        {
          value: Period.ONE_YEAR,
          label: periodPrefix + Period.ONE_YEAR,
          isActive: false,
        },
        {
          value: Period.MAX,
          label: periodPrefix + Period.MAX,
          isActive: true,
        },
        {
          value: currentYear,
          label: currentYear.toString(),
          isActive: false,
        },
        {
          value: currentYear - 1,
          label: (currentYear - 1).toString(),
          isActive: false,
        },
        {
          value: currentYear - 2,
          label: (currentYear - 2).toString(),
          isActive: false,
        },
      ],
    };
  }
}
